import React from 'react';
import './RecentProjects.css'
import g1 from '../../../images/portfolio/g1.jpg';
import g02 from '../../../images/portfolio/g02.png';
import g3 from '../../../images/portfolio/g3.png';
import g4 from '../../../images/portfolio/g4.png';
import g5 from '../../../images/portfolio/g5.png';
import g6 from '../../../images/portfolio/g6.png';
import { useHistory } from 'react-router';

const RecentProjects = () => {
    const history = useHistory();
    return (
        <section className="mh-portfolio pt-5" id="mh-portfolio">
            <div className="container">
                <div className="row">
                    <div className="section-title col-sm-12">
                        <h3 data-aos="fade-right">Recent Works</h3>
                    </div>
                    <br /><br /><br />
                    <div className="part col-sm-12">


                        <div className="mh-project-gallery col-sm-12" id="project-gallery">
                            <div className="portfolioContainer row">
                                <div className="grid-item col-md-4"   data-aos="zoom-in" data-aos-duration="2000">
                                    <a href="https://dress-house24.web.app/" target="_blank">
                                        <figure>
                                            <img src={g3} alt="" />
                                            <figcaption className="fig-caption">
                                                <i className="fa fa-eye"></i>
                                                <h5 className="title">Preview</h5>
                                                <h6 className="sub-title">Dress house24</h6>
                                            </figcaption>
                                        </figure>
                                    </a>
                                </div>
                                <div className="grid-item col-md-4" data-aos="zoom-in"data-aos-duration="2000">
                                    <a href="https://shahinuralambhuiyan.github.io/Hungry-Monster/index.html" target="_blank">
                                        <figure>
                                            <img src={g02} alt="" />
                                            <figcaption className="fig-caption">
                                                <i className="fa fa-eye"></i>
                                                <h5 className="title">Preview</h5>
                                                <span className="sub-title">Hungry Monster</span>
                                            </figcaption>
                                        </figure>
                                    </a>
                                </div>


                                <div className="grid-item col-md-4" data-aos="zoom-in" data-aos-duration="2000">
                                    <a href="https://doctors-portal-usa.netlify.app/" target="_blank">
                                        <figure>
                                            <img src={g1} alt="" />
                                            <figcaption className="fig-caption">
                                                <i className="fa fa-eye"></i>
                                                <h5 className="title">Preview</h5>
                                                <span className="sub-title">Doctors portal</span>
                                            </figcaption>
                                        </figure>
                                    </a>
                                </div>

                                <div className="grid-item col-md-4" data-aos="zoom-in" data-aos-duration="2000">
                                    <a href="https://budget-bd.netlify.app/" target="_blank">
                                        <figure>
                                            <img src={g5} alt="" />
                                            <figcaption className="fig-caption">
                                                <i className="fa fa-eye"></i>
                                                <h5 className="title">Preview</h5>
                                                <span className="sub-title">Budget App</span>
                                            </figcaption>
                                        </figure>
                                    </a>
                                </div>

                                <div className="grid-item col-md-4" data-aos="zoom-in" data-aos-duration="2000">
                                    <a href="https://photo-phactoryy.web.app/" target="_blank">
                                        <figure>
                                            <img src={g4} alt="" />
                                            <figcaption className="fig-caption">
                                                <i className="fa fa-eye"></i>
                                                <h5 className="title">Preview</h5>
                                                <span className="sub-title">Photo phactory</span>
                                            </figcaption>
                                        </figure>
                                    </a>
                                </div>

                                <div className="grid-item col-md-4" data-aos="zoom-in" data-aos-duration="2000">
                                    <a href="https://disney-clone-d1e27.web.app/" target="_blank">
                                        <figure>
                                            <img src={g6} alt="" />
                                            <figcaption className="fig-caption">
                                                <i className="fa fa-eye"></i>
                                                <h5 className="title">Preview</h5>
                                                <span className="sub-title">Disney World</span>
                                            </figcaption>
                                        </figure>
                                    </a>
                                </div>
                            </div>
                            <div className='d-flex justify-content-center align-items-center p-3' data-aos="fade-up">
                                <button className="btn btn-danger w-25" onClick={()=> history.push('/work')}>
                                    See more&nbsp; <i class="fa fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default RecentProjects;